var map = {
	"./1.svg": [
		78305,
		8305
	],
	"./arrow-down.svg": [
		83801,
		3801
	],
	"./arrow-right.svg": [
		51780,
		1780
	],
	"./back.svg": [
		57146,
		7146
	],
	"./back_customization.svg": [
		89882,
		9882
	],
	"./beauties.svg": [
		40626,
		626
	],
	"./buttons/arrow_left.svg": [
		91766,
		1766
	],
	"./buttons/arrow_right.svg": [
		41711,
		1711
	],
	"./buttons/back.svg": [
		70856,
		856
	],
	"./buttons/back_customization.svg": [
		36065,
		6065
	],
	"./buttons/back_dark.svg": [
		1813,
		1813
	],
	"./buttons/ball.svg": [
		74721,
		4721
	],
	"./buttons/basket.svg": [
		71903,
		1903
	],
	"./buttons/beauty-icon.svg": [
		54628,
		4628
	],
	"./buttons/beauty-quiz.svg": [
		77400,
		7400
	],
	"./buttons/box.svg": [
		8758,
		8758
	],
	"./buttons/brush.svg": [
		6740,
		6740
	],
	"./buttons/check.svg": [
		29514,
		9514
	],
	"./buttons/chevron-down.svg": [
		57733,
		7733
	],
	"./buttons/chevron-right.svg": [
		99189,
		9189
	],
	"./buttons/closeModal.svg": [
		81189,
		1189
	],
	"./buttons/conv.svg": [
		86413,
		6413
	],
	"./buttons/coupon.svg": [
		62934,
		2934
	],
	"./buttons/cross.svg": [
		70562,
		562
	],
	"./buttons/done.svg": [
		65122,
		5122
	],
	"./buttons/equipped-violet.svg": [
		23136,
		3136
	],
	"./buttons/equipped.svg": [
		98954,
		8954
	],
	"./buttons/friends.svg": [
		80031,
		31
	],
	"./buttons/gift-icon.svg": [
		3184,
		3184
	],
	"./buttons/gifts.svg": [
		3580,
		3580
	],
	"./buttons/heart.svg": [
		83735,
		3735
	],
	"./buttons/info.svg": [
		49488,
		9488
	],
	"./buttons/like.svg": [
		68949,
		8949
	],
	"./buttons/nav-next.svg": [
		34962,
		4962
	],
	"./buttons/nav-prev.svg": [
		57226,
		7226
	],
	"./buttons/navigation/challenge.svg": [
		29566,
		9566
	],
	"./buttons/navigation/custom.svg": [
		36503,
		6503
	],
	"./buttons/navigation/draw.svg": [
		37854,
		7854
	],
	"./buttons/navigation/games.svg": [
		32205,
		2205
	],
	"./buttons/navigation/main.svg": [
		52010,
		2010
	],
	"./buttons/navigation/rating.svg": [
		55373,
		5373
	],
	"./buttons/navigation/roadmap.svg": [
		17746,
		7746
	],
	"./buttons/navigation/tasks.svg": [
		81141,
		1141
	],
	"./buttons/pause-q.svg": [
		10094,
		94
	],
	"./buttons/pause.svg": [
		38600,
		8600
	],
	"./buttons/per.svg": [
		63624,
		3624
	],
	"./buttons/person.svg": [
		54902,
		4902
	],
	"./buttons/present-icon.svg": [
		28632,
		8632
	],
	"./buttons/present.svg": [
		52302,
		2302
	],
	"./buttons/product-basket.svg": [
		56607,
		6607
	],
	"./buttons/pumpkin.svg": [
		70569,
		569
	],
	"./buttons/purchases.svg": [
		24567,
		4567
	],
	"./buttons/quiz-points.svg": [
		65262,
		5262
	],
	"./buttons/roadmap.svg": [
		61809,
		1809
	],
	"./buttons/rotate.svg": [
		8311,
		8311
	],
	"./buttons/sales-nav.svg": [
		24380,
		4380
	],
	"./buttons/sales.svg": [
		80119,
		119
	],
	"./buttons/select-country-icon.svg": [
		74725,
		4725
	],
	"./buttons/select-lang-icon.svg": [
		15023,
		5023
	],
	"./buttons/select.svg": [
		69757,
		9757
	],
	"./buttons/shower.svg": [
		56927,
		6927
	],
	"./buttons/soap.svg": [
		92630,
		2630
	],
	"./buttons/task-new.svg": [
		5112,
		5112
	],
	"./buttons/tasks.svg": [
		57249,
		7249
	],
	"./buttons/to-bath.svg": [
		8843,
		8843
	],
	"./buttons/to-main-2.svg": [
		51743,
		1743
	],
	"./buttons/to-main.svg": [
		79768,
		9768
	],
	"./buttons/to-procedure.svg": [
		26014,
		6014
	],
	"./buttons/to-store.svg": [
		57802,
		7802
	],
	"./buttons/volume-m-off.svg": [
		79661,
		9661
	],
	"./buttons/volume-m-on.svg": [
		28663,
		8663
	],
	"./buttons/winnings-nav-2.svg": [
		82041,
		2041
	],
	"./buttons/winnings-nav.svg": [
		12339,
		2339
	],
	"./challenges/arrow.svg": [
		67497,
		7497
	],
	"./charm.svg": [
		93377,
		3377
	],
	"./check.svg": [
		41281,
		1281
	],
	"./coin-black.svg": [
		26362,
		6362
	],
	"./coin-g.svg": [
		46438,
		6438
	],
	"./coin.svg": [
		39066,
		9066
	],
	"./coinP.svg": [
		45539,
		5539
	],
	"./coins.svg": [
		46472,
		6472
	],
	"./cross.svg": [
		78416,
		8416
	],
	"./customization/arrow.svg": [
		38374,
		8374
	],
	"./customization/char/cap.svg": [
		31168,
		1168
	],
	"./customization/char/glasses.svg": [
		84950,
		4950
	],
	"./customization/char/hair.svg": [
		31377,
		1377
	],
	"./customization/char/pants.svg": [
		53322,
		3322
	],
	"./customization/char/pouch.svg": [
		20518,
		518
	],
	"./customization/char/shirt.svg": [
		67458,
		7458
	],
	"./customization/check-room.svg": [
		96903,
		6903
	],
	"./customization/check.svg": [
		74086,
		4086
	],
	"./customization/clothes.svg": [
		53277,
		3277
	],
	"./customization/gifts.svg": [
		8786,
		8786
	],
	"./customization/room.svg": [
		82110,
		2110
	],
	"./customization/room/bookshelf.svg": [
		8776,
		8776
	],
	"./customization/room/carpet.svg": [
		98230,
		8230
	],
	"./customization/room/chair.svg": [
		11902,
		1902
	],
	"./customization/room/clock.svg": [
		58081,
		8081
	],
	"./customization/room/picture.svg": [
		60068,
		68
	],
	"./customization/room/rack.svg": [
		85789,
		5789
	],
	"./customization/shower.svg": [
		71199,
		1199
	],
	"./energy-b.svg": [
		81626,
		1626
	],
	"./energy-g.svg": [
		20356,
		356
	],
	"./energy.svg": [
		81180,
		1180
	],
	"./equipped.svg": [
		99686,
		9686
	],
	"./gift-coin.svg": [
		85949,
		5949
	],
	"./gifts.svg": [
		69531,
		9531
	],
	"./header/soc/instagram.svg": [
		62024,
		2024
	],
	"./header/soc/snapchat.svg": [
		92713,
		2713
	],
	"./header/soc/tg.svg": [
		93314,
		3314
	],
	"./header/soc/tik-tok.svg": [
		47004,
		7004
	],
	"./header/soc/vk.svg": [
		76884,
		6884
	],
	"./header/soc/yt.svg": [
		30728,
		728
	],
	"./header/top/app.svg": [
		44681,
		4681
	],
	"./header/top/tg.svg": [
		90508,
		508
	],
	"./header/top/whatsapp.svg": [
		16896,
		6896
	],
	"./heart.svg": [
		25860,
		5860
	],
	"./help/mob/1.svg": [
		32603,
		2603
	],
	"./help/mob/2.svg": [
		60973,
		973
	],
	"./help/mob/3.svg": [
		99374,
		9374
	],
	"./help/mob/4.svg": [
		18150,
		8150
	],
	"./help/mob/5.svg": [
		41854,
		1854
	],
	"./help/mob/6.svg": [
		25089,
		5089
	],
	"./help/mob/7.svg": [
		58798,
		8798
	],
	"./help/mob/8.svg": [
		14274,
		4274
	],
	"./help/mob/instagram.svg": [
		97613,
		7613
	],
	"./help/mob/snapchat.svg": [
		52756,
		2756
	],
	"./help/mob/tik-tok.svg": [
		85685,
		5685
	],
	"./logo.svg": [
		65712,
		5712
	],
	"./logoD.svg": [
		71976,
		1976
	],
	"./logoMe.svg": [
		4875,
		4875
	],
	"./logo_ga.svg": [
		90589,
		589
	],
	"./main/beauties.svg": [
		26200,
		6200
	],
	"./main/charm-clickable.svg": [
		16149,
		6149
	],
	"./main/coin.svg": [
		48453,
		8453
	],
	"./main/cool-icon.svg": [
		26011,
		6011
	],
	"./main/energy-clickable.svg": [
		80341,
		341
	],
	"./main/energy.svg": [
		20645,
		645
	],
	"./main/fire-icon.svg": [
		67402,
		7402
	],
	"./main/friends.svg": [
		85510,
		5510
	],
	"./main/gifts-white.svg": [
		78794,
		8794
	],
	"./main/heart-icon.svg": [
		21675,
		1675
	],
	"./main/help.svg": [
		78522,
		8522
	],
	"./main/level-frame.svg": [
		30274,
		274
	],
	"./main/like-icon.svg": [
		83477,
		3477
	],
	"./main/like.svg": [
		98262,
		8262
	],
	"./main/likes.svg": [
		53409,
		3409
	],
	"./main/room-mask.svg": [
		83092,
		3092
	],
	"./main/task-coin.svg": [
		25332,
		5332
	],
	"./main/task-coupon.svg": [
		61701,
		1701
	],
	"./main/task-energy.svg": [
		85322,
		5322
	],
	"./money.svg": [
		21100,
		1100
	],
	"./myGift/1.svg": [
		59386,
		9386
	],
	"./myGift/2.svg": [
		75044,
		5044
	],
	"./myGift/home.svg": [
		96172,
		6172
	],
	"./myGift/load.svg": [
		37009,
		7009
	],
	"./myGift/postcard.svg": [
		91974,
		1974
	],
	"./nav-next.svg": [
		75284,
		5284
	],
	"./nav-prev.svg": [
		86233,
		6233
	],
	"./pause.svg": [
		4922,
		4922
	],
	"./profile/fire.svg": [
		74512,
		4512
	],
	"./profile/heart.svg": [
		41593,
		1593
	],
	"./profile/i.svg": [
		21350,
		1350
	],
	"./profile/likes.svg": [
		53999,
		3999
	],
	"./profile/person.svg": [
		83499,
		3499
	],
	"./profile/smile.svg": [
		91682,
		1682
	],
	"./redesign/check.svg": [
		31351,
		1351
	],
	"./redesign/coin.svg": [
		80640,
		640
	],
	"./resources/energy-icon-black.svg": [
		42797,
		2797
	],
	"./rotate.svg": [
		82254,
		2254
	],
	"./score.svg": [
		70677,
		677
	],
	"./shop/coin-icon.svg": [
		62711,
		2711
	],
	"./shop/gift-icon.svg": [
		85469,
		5469
	],
	"./shop/shop-coin.svg": [
		45969,
		5969
	],
	"./sunRabbit/back.svg": [
		19798,
		9798
	],
	"./sunRabbit/completed.svg": [
		55180,
		5180
	],
	"./sunRabbit/hint.svg": [
		42103,
		2103
	],
	"./sunRabbit/lightning.svg": [
		97518,
		7518
	],
	"./tasks/arr.svg": [
		43276,
		3276
	],
	"./tasks/task-arrow-2.svg": [
		32992,
		2992
	],
	"./tasks/task-arrow-3.svg": [
		54167,
		4167
	],
	"./tasks/task-arrow-4.svg": [
		66767,
		6767
	],
	"./tasks/task-arrow-5.svg": [
		43773,
		3773
	],
	"./tasks/task-arrow.svg": [
		60427,
		427
	],
	"./tg.svg": [
		90570,
		570
	],
	"./tickets.svg": [
		26219,
		6219
	],
	"./win.svg": [
		20665,
		665
	],
	"./wish/1.svg": [
		89615,
		9615
	],
	"./wish/2.svg": [
		4974,
		4974
	],
	"./wish/3.svg": [
		16058,
		6058
	],
	"./wish/accept.svg": [
		72030,
		2030
	],
	"./wish/close.svg": [
		2344,
		2344
	],
	"./wish/next.svg": [
		69730,
		9730
	],
	"./wish/prev.svg": [
		3981,
		3981
	],
	"./wish/repeat.svg": [
		96995,
		6995
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35715;
module.exports = webpackAsyncContext;